import {
  FhirPractitioner,
  getPractitionerNameFromResource,
} from "./fhir-init-utils";

interface ProviderInfo {
  full_name?: string;
  specialty?: string;
  role?: string;
  salutation?: string;
  designation?: string;
  credential?: string;
  credentials?: string | string[];
  suffix?: string;
}

interface FhirClientUser {
  name?: string;
}

export const getHomeScreenUserName = (
  providerInfo?: ProviderInfo | null,
  client?: { user?: FhirClientUser } | null,
  practitioner?: FhirPractitioner | null
): string => {
  if (providerInfo?.full_name?.trim()) {
    return providerInfo.full_name.trim();
  }

  const fhirName = getPractitionerNameFromResource(practitioner);
  if (fhirName) return fhirName;

  if (client?.user?.name?.trim()) {
    return client.user.name.trim();
  }

  return "";
};

export const getHomeScreenUserRole = (
  providerInfo?: ProviderInfo | null,
  practitioner?: FhirPractitioner | null
): string => {
  return (
    providerInfo?.specialty?.trim() ||
    providerInfo?.role?.trim() ||
    practitioner?.qualification?.[0]?.code?.text?.trim() ||
    ""
  );
};

export const getProviderSalutation = (
  providerInfo?: ProviderInfo | null,
  practitioner?: FhirPractitioner | null
): string => {
  const rawCredentials = providerInfo?.credentials;
  const credentials = Array.isArray(rawCredentials)
    ? rawCredentials
    : [rawCredentials];
  const candidates = [
    providerInfo?.salutation,
    providerInfo?.designation,
    providerInfo?.credential,
    ...credentials,
    providerInfo?.suffix,
    practitioner?.qualification?.[0]?.code?.text,
  ];

  return candidates.find(
    (candidate): candidate is string =>
      typeof candidate === "string" && Boolean(candidate.trim())
  )?.trim() ?? "";
};

/** Matches the Home screen header: "Inderej Singh · Internal Medicine" */
export const getHomeScreenProviderLabel = (
  providerInfo?: ProviderInfo | null,
  client?: { user?: FhirClientUser } | null,
  practitioner?: FhirPractitioner | null
): string => {
  const userName = getHomeScreenUserName(providerInfo, client, practitioner);
  const userRole = getHomeScreenUserRole(providerInfo, practitioner);

  if (!userName) return "";
  return userRole ? `${userName} · ${userRole}` : userName;
};

/** Default signature text — name only, e.g. "Inderej Singh" (no FHIR client fallback) */
export const getHomeScreenSignatureDefault = (
  providerInfo?: ProviderInfo | null,
  _client?: { user?: FhirClientUser } | null,
  practitioner?: FhirPractitioner | null
): string => getHomeScreenUserName(providerInfo, null, practitioner);
